import React from "react";

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirm Action",
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  className = "",
}) => {
  if (!isOpen) return null; // Don't render if the modal is not open

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div
        className={`bg-white p-4 lg:p-6 rounded-lg shadow-lg w-[85vw] sm:w-[80vw] md:w-2/3 lg:w-[30%] ${className}`}
      >
        <h2 className="text-lg text-center font-semibold pb-4">{title}</h2>
        <p className="text-sm lg:text-base text-center">{message}</p>
        <div className="flex flex-row justify-center space-x-4 mt-6">
          <button
            className="bg-red-500 rounded-[10px] text-sm lg:text-base py-2 px-8 lg:p-2 mb-4  lg:px-10 text-white"
            onClick={onClose}
          >
            {cancelText}
          </button>
          <button
            className="bg-green-700 rounded-[10px] text-sm lg:text-base py-2 px-8 lg:p-2 mb-4  lg:px-10 text-white "
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
